import { supabase } from "../lib/supabase";

/**
 * Forwarding service - handles forwarding reports to COCT
 */
export const forwardingService = {
  /**
   * Forward a report to COCT via email
   * @param {string} reportId - The UUID of the report to forward
   * @returns {Promise<Object>} Result of the forwarding operation
   */
  async forwardToCOCT(reportId) {
    try {
      const { data, error } = await supabase.functions.invoke('forward-to-coct', {
        body: { reportId }
      });

      if (error) throw error;

      return {
        success: true,
        data,
      };
    } catch (error) {
      console.error('Error forwarding report to COCT:', error);
      return {
        success: false,
        error: error.message,
      };
    }
  },

  /**
   * Check if a report has been forwarded
   * @param {string} reportId - The UUID of the report
   * @returns {Promise<Object>} Forwarding status
   */
  async getForwardingStatus(reportId) {
    try {
      const { data, error } = await supabase
        .from('reports')
        .select('forwarded_via, forwarded_at, forwarding_error')
        .eq('id', reportId)
        .single();

      if (error) throw error;

      return {
        isForwarded: !!data.forwarded_at,
        forwardedVia: data.forwarded_via,
        forwardedAt: data.forwarded_at,
        error: data.forwarding_error,
      };
    } catch (error) {
      console.error('Error checking forwarding status:', error);
      throw error;
    }
  },
};
